export default {
  title: 'Brandsynkronisering – brands',
  subtitle:
    'Oversigt over alle restauranter i gruppen og deres synkroniserede funktioner. Kun kontoadministratoren kan foretage ændringer.',
  alert: {
    message: 'Kun adgang for administratorer',
    description:
      'Ændringer af hovedmenuen, priser og tilbud kan kun foretages af kontoadministratoren. Alle lokationer modtager automatisk opdateringer.',
  },
  locations: {
    title: 'Lokationer',
    description: 'Alle restauranter i gruppen, der deler hovedmenuen og indstillingerne',
    locations_zero: '0 lokationer',
    locations_one: '1 lokation',
    locations_other: '{{count}} lokationer',
    synced: 'Synkroniseret',
  },
  features: {
    title: 'Synkroniserede funktioner',
    description: 'Disse funktioner styres af hovedindstillingerne',
    menus: {
      title: 'Hovedmenu',
      desription: 'Menupunkter, kategorier og beskrivelser synkroniseres på tværs af alle lokationer',
    },
    smart_pricing: {
      title: 'Smart prissætning',
      desription: 'Prisregler og justeringer synkroniseres på tværs af alle lokationer',
    },
    offers: {
      title: 'Tilbud og kampagner',
      desription: 'Aktive tilbud, rabatter og kampagner synkroniseres på tværs af alle lokationer',
    },
  },
};
